import type { SupportedLanguageCode } from './config';

export type TranslationCatalog = Partial<Record<string, string>>;

export const SHELL_MESSAGES: Record<SupportedLanguageCode, TranslationCatalog> = {
  en: {},
  de: {
    Overview: 'Übersicht',
    Academy: 'Academy',
    Community: 'Community',
    Launchpad: 'Launchpad',
    Support: 'Support',
    Shop: 'Shop',
    Portfolio: 'Portfolio',
    Library: 'Library',
    Applications: 'Anwendungen',
    Dashboard: 'Dashboard',
    Settings: 'Einstellungen',
    'Data Protection': 'Datenschutz',
    'Data Privacy': 'Privatsphäre-Einstellungen',
    'Privacy Policy': 'Datenschutzerklärung',
    'Cookie Policy': 'Cookie-Richtlinie',
    'Cookie Settings': 'Cookie-Einstellungen',
    'Legal information': 'Rechtliche Informationen',
    'Main navigation': 'Hauptnavigation',
    'Expand sidebar': 'Seitenleiste erweitern',
    'Collapse sidebar': 'Seitenleiste einklappen',
    'Open user menu': 'Benutzermenü öffnen',
    'Close user menu': 'Benutzermenü schließen',
    'Close WIANCO AI': 'WIANCO AI schließen',
    'Context: {{area}}': 'Kontext: {{area}}',
    'Narrow assistant panel': 'Assistenten schmaler machen',
    'Widen assistant panel': 'Assistenten breiter machen',
    'Resize assistant panel': 'Assistentenbreite ändern',
    'User actions': 'Benutzeraktionen',
    Cookies: 'Cookies',
    Logout: 'Abmelden',
    'Not signed in': 'Nicht angemeldet',
    Authenticated: 'Authentifiziert',
    Guest: 'Gast',
    Unavailable: 'Nicht verfügbar',
    authenticated: 'authentifiziert',
    guest: 'gast',
    admin: 'Administrator',
    Administrator: 'Administrator',
    moderator: 'Moderator',
    user: 'Benutzer',
    User: 'Benutzer',
    partner: 'Partner',
    'Open navigation menu': 'Navigationsmenü öffnen',
    Menu: 'Menü',
    'Open menu': 'Menü Öffnen',
    'Close menu': 'Menü schließen',
    'Switch to light mode': 'In den hellen Modus wechseln',
    'Switch to dark mode': 'In den dunklen Modus wechseln',
    Notifications: 'Benachrichtigungen',
    'Loading...': 'Wird geladen...',
    'Failed to load component': 'Komponente konnte nicht geladen werden',
    'An unexpected error occurred while loading this component.':
      'Beim Laden dieser Komponente ist ein unerwarteter Fehler aufgetreten.',
    'Try Again': 'Erneut versuchen',
    Retry: 'Erneut laden',
    'Failed to load {{name}}': '{{name}} konnte nicht geladen werden',
    'Unknown embedding type: {{type}}': 'Unbekannter Einbettungstyp: {{type}}',
    'Loading workspace...': 'Arbeitsbereich wird geladen...',
    'Pulling latest service context and activity data.':
      'Aktueller Service-Kontext und Aktivitätsdaten werden geladen.',
    Welcome: 'Willkommen',
    'Welcome to the WIANCO Portal': 'Willkommen im WIANCO Portal',
    'Everything around EMMA and our product worlds, in one place.':
      'Alles rund um EMMA und unsere Produktwelten an einem Ort.',
    Services: 'Dienste',
    'Welcome back, {{name}}.': 'Willkommen zurück, {{name}}.',
    'System {{status}}': 'System {{status}}',
    healthy: 'stabil',
    degraded: 'beeinträchtigt',
    down: 'offline',
    'Administrator access includes operational KPIs and service health across the portal.':
      'Administratorzugang zeigt operative KPIs und den Servicezustand im gesamten Portal.',
    'This workspace highlights the company and contact information linked to your portal access so customers and partners can quickly confirm their account context.':
      'Dieser Arbeitsbereich zeigt die mit Ihrem Portalzugang verknüpften Firmen- und Kontaktdaten, damit Kunden und Partner ihren Kontokontext schnell prüfen können.',
    'The WIANCO Portal is the entry point for platform applications. Open embedded services from one authenticated workspace and monitor operational status at a glance.':
      'Das WIANCO Portal ist der Einstiegspunkt für Plattformanwendungen. Öffnen Sie eingebettete Dienste aus einem authentifizierten Arbeitsbereich und überwachen Sie den Betriebsstatus auf einen Blick.',
    'Total Users': 'Benutzer gesamt',
    'Active Users': 'Aktive Benutzer',
    'Monthly Revenue': 'Monatlicher Umsatz',
    'Embedded Services': 'Eingebettete Dienste',
    'Associated Company': 'Zugeordnetes Unternehmen',
    'Contact Entity': 'Kontaktentität',
    'Lifecycle Stage': 'Lifecycle-Status',
    'Portal Access': 'Portalzugang',
    'Launch Pads': 'Schnellzugriffe',
    'A knowledge base where WIANCO is publishing blogposts to various topics.':
      'Eine Wissensdatenbank, in der WIANCO Blogbeiträge zu verschiedenen Themen veröffentlicht.',
    'A discussion space for everyone to ask questions, share best practices, and discover the most helpful answers and ideas.':
      'Ein Diskussionsraum für alle, um Fragen zu stellen, Best Practices zu teilen und die hilfreichsten Antworten und Ideen zu entdecken.',
    'Open Launchpad inside the portal workspace.': 'Launchpad im Portal-Arbeitsbereich öffnen.',
    'Create and manage your support requests.': 'Erstellen und verwalten Sie Ihre Supportanfragen.',
    'Review account-specific offers and prepare HubSpot-backed order requests.':
      'Prüfen Sie kontospezifische Angebote und bereiten Sie HubSpot-gestützte Bestellanfragen vor.',
    'Review your deals, products, and associated companies.':
      'Prüfen Sie Ihre Deals, Produkte und zugeordneten Unternehmen.',
    'Browse and download the documents available to your account.':
      'Durchsuchen und laden Sie die für Ihr Konto verfügbaren Dokumente herunter.',
    'Discover process solutions, modules, assets and bundles for EMMA.':
      'Entdecken Sie Prozesslösungen, Module, Assets und Bundles für EMMA.',
    'Marketplace is not available for your account.':
      'Marketplace ist für Ihr Konto nicht verfügbar.',
    'Marketplace service is not configured in {{name}}.':
      'Der Marketplace-Dienst ist in {{name}} nicht konfiguriert.',
    'Portfolio is not available for your account.': 'Portfolio ist für Ihr Konto nicht verfügbar.',
    'Portfolio service is not configured in {{name}}.':
      'Der Portfolio-Dienst ist in {{name}} nicht konfiguriert.',
    'Library is not available for your account.': 'Library ist für Ihr Konto nicht verfügbar.',
    'Library service is not configured in {{name}}.':
      'Der Library-Dienst ist in {{name}} nicht konfiguriert.',
    'Open {{name}} inside the portal workspace.': '{{name}} im Portal-Arbeitsbereich öffnen.',
    'Inspect platform metrics and recent events.':
      'Plattformmetriken und aktuelle Ereignisse prüfen.',
    'Manage preferences and notification defaults.':
      'Einstellungen und Benachrichtigungsstandards verwalten.',
    'Live Services': 'Live-Dienste',
    '{{type}} integration': '{{type}}-Integration',
    'No services configured in runtime config.':
      'In der Laufzeitkonfiguration sind keine Dienste hinterlegt.',
    Revenue: 'Umsatz',
    'System Status': 'Systemstatus',
    'Failed to fetch dashboard data. Please try again later.':
      'Dashboard-Daten konnten nicht geladen werden. Bitte später erneut versuchen.',
    'Loading dashboard...': 'Dashboard wird geladen...',
    'Operational Dashboard': 'Betriebs-Dashboard',
    'Unified telemetry snapshot across portal integrations and user activity.':
      'Zentraler Telemetrie-Überblick über Portal-Integrationen und Benutzeraktivität.',
    'Recent Activity': 'Letzte Aktivität',
    '{{count}} events': '{{count}} Ereignisse',
    'No activity recorded.': 'Keine Aktivität vorhanden.',
    'user login': 'Benutzeranmeldung',
    'settings update': 'Einstellungen aktualisiert',
    'app launch': 'Anwendung gestartet',
    'system alert': 'Systemhinweis',
    'Successful login from London, UK': 'Erfolgreiche Anmeldung aus London, UK',
    'Changed theme preference to Dark Mode': 'Design auf Dunkelmodus geändert',
    'Launched Dashboard Application': 'Dashboard-Anwendung gestartet',
    'Scheduled maintenance completed': 'Geplante Wartung abgeschlossen',
    'Community service is not configured in {{name}}.':
      'Der Community-Dienst ist in {{name}} nicht konfiguriert.',
    'LaunchPad service is not configured in {{name}}.':
      'Der LaunchPad-Dienst ist in {{name}} nicht konfiguriert.',
    'Support service is not configured in {{name}}.':
      'Der Support-Dienst ist in {{name}} nicht konfiguriert.',
    'Shop service is not configured in {{name}}.':
      'Der Shop-Dienst ist in {{name}} nicht konfiguriert.',
    'LaunchPad is not available for your account.': 'LaunchPad ist für Ihr Konto nicht verfügbar.',
    'Shop is not available for your account.': 'Der Shop ist für Ihr Konto nicht verfügbar.',
    'Embedded tools run in this portal with shared authentication and consent context.':
      'Eingebettete Werkzeuge laufen in diesem Portal mit gemeinsamem Authentifizierungs- und Einwilligungskontext.',
    'Launch this application inside the unified portal workspace.':
      'Diese Anwendung im gemeinsamen Portal-Arbeitsbereich starten.',
    'No applications configured in `EMBEDDED_SERVICES`.':
      'In `EMBEDDED_SERVICES` sind keine Anwendungen konfiguriert.',
    Back: 'Zurück',
    'Back to community': 'Zurück zur Community',
    'Back to login': 'Zurück zur Anmeldung',
    'Starting secure login': 'Sichere Anmeldung wird gestartet',
    Login: 'Anmelden',
    Register: 'Registrieren',
    'Portal sign-in': 'Portalanmeldung',
    'Authentication Error:': 'Authentifizierungsfehler:',
    'Continue with SSO': 'Mit SSO fortfahren',
    'SSO is managed by the platform identity team.':
      'SSO wird vom Plattform-Identity-Team verwaltet.',
    'No account yet?': 'Noch kein Zugang?',
    'Use your HubSpot contact email to receive a sign-in email.':
      'Verwenden Sie Ihre HubSpot-Kontakt-E-Mail, um eine Anmelde-E-Mail zu erhalten.',
    'Enter your work email and we will send you a sign-in link.':
      'Geben Sie Ihre geschäftliche E-Mail an, dann schicken wir Ihnen einen Anmeldelink.',
    'Work email': 'Geschäftliche E-Mail',
    'Send sign-in email': 'Anmelde-E-Mail senden',
    'If your email is eligible for support access, you will receive a sign-in email shortly.':
      'Wenn Ihre E-Mail für den Supportzugang berechtigt ist, erhalten Sie in Kürze eine Anmelde-E-Mail.',
    'Workspace Settings': 'Arbeitsbereichseinstellungen',
    'Configure workspace preferences, language, visual theme and notification defaults.':
      'Arbeitsbereichseinstellungen, Sprache, Erscheinungsbild und Benachrichtigungsstandards konfigurieren.',
    'Contact Profile': 'Kontaktprofil',
    'General contact and CRM information available to this workspace.':
      'Allgemeine Kontakt- und CRM-Informationen, die diesem Arbeitsbereich zur Verfügung stehen.',
    'Company Details': 'Unternehmensdetails',
    'Company relationship and account context synchronized for this portal access.':
      'Unternehmensbeziehung und Kontokontext, die für diesen Portalzugang synchronisiert wurden.',
    Profile: 'Profil',
    'Loading profile...': 'Profil wird geladen...',
    'Appearance and Notifications': 'Erscheinungsbild und Benachrichtigungen',
    Language: 'Sprache',
    English: 'Englisch',
    Deutsch: 'Deutsch',
    Theme: 'Design',
    Dark: 'Dunkel',
    Light: 'Hell',
    'Enable email notifications': 'E-Mail-Benachrichtigungen aktivieren',
    'Save Settings': 'Einstellungen speichern',
    'Preferences applied locally.': 'Einstellungen wurden lokal angewendet.',
    'Settings saved successfully.': 'Einstellungen wurden erfolgreich gespeichert.',
    'Failed to save settings. Preferences are still applied locally.':
      'Einstellungen konnten nicht gespeichert werden. Die lokalen Einstellungen bleiben aktiv.',
    'Last updated: {{date}}': 'Zuletzt aktualisiert: {{date}}',
    'Effective date: {{date}}': 'Stand: {{date}}',
    'Back to Portal': 'Zum Portal',
    '1. Introduction': '1. Einleitung',
    'Welcome to the WIANCO Portal. We are committed to protecting your personal information and your privacy rights while using this workspace.':
      'Willkommen im WIANCO Portal. Wir verpflichten uns, Ihre personenbezogenen Daten und Ihre Datenschutzrechte bei der Nutzung dieses Arbeitsbereichs zu schützen.',
    '2. Information We Collect': '2. Welche Daten wir erfassen',
    'We collect personal information that you provide directly when you authenticate or use platform features.':
      'Wir erfassen personenbezogene Daten, die Sie direkt bei der Anmeldung oder bei der Nutzung von Plattformfunktionen angeben.',
    '3. Use of Cookies': '3. Verwendung von Cookies',
    'We use cookies to support session handling and preferences. See our {{policy}} for details.':
      'Wir verwenden Cookies für Sitzungsverwaltung und Einstellungen. Details finden Sie in unserer {{policy}}.',
    '4. Your Privacy Rights': '4. Ihre Datenschutzrechte',
    'Depending on your jurisdiction, you may request access, correction, deletion, or restriction of your personal data.':
      'Je nach Rechtsraum können Sie Auskunft, Berichtigung, Löschung oder Einschränkung Ihrer personenbezogenen Daten verlangen.',
    '5. Contact': '5. Kontakt',
    'If you have questions, contact the platform support team.':
      'Bei Fragen wenden Sie sich bitte an das Plattform-Support-Team.',
    'What are cookies?': 'Was sind Cookies?',
    'Cookies and similar browser storage technologies retain small amounts of information on your device. The Portal uses them for authentication, security, navigation and interface preferences.':
      'Cookies und ähnliche Browser-Speichertechnologien speichern kleine Informationsmengen auf Ihrem Endgerät. Das Portal verwendet sie für Authentifizierung, Sicherheit, Navigation und Oberflächeneinstellungen.',
    'Managing your cookie preferences': 'Verwaltung Ihrer Cookie-Einstellungen',
    'You can update preferences at any time from the cookie settings dialog.':
      'Sie können Ihre Einstellungen jederzeit im Cookie-Einstellungsdialog ändern.',
    'Manage Cookie Preferences': 'Cookie-Einstellungen verwalten',
    'The cookies we use': 'Von uns verwendete Cookies',
    '(Required)': '(Erforderlich)',
    '(Optional)': '(Optional)',
    Name: 'Name',
    Provider: 'Anbieter',
    Purpose: 'Zweck',
    Expiry: 'Ablauf',
    Type: 'Typ',
    Company: 'Unternehmen',
    Relationship: 'Beziehung',
    Industry: 'Branche',
    Website: 'Website',
    'Support Tier': 'Support-Stufe',
    'Job Title': 'Position',
    Department: 'Abteilung',
    'Preferred Language': 'Bevorzugte Sprache',
    'Last Sync': 'Letzte Synchronisierung',
    Internal: 'Intern',
    Customer: 'Kunde',
    Partner: 'Partner',
    Priority: 'Priorisiert',
    Standard: 'Standard',
    Strategic: 'Strategisch',
    'Internal Contact': 'Interner Kontakt',
    'Customer Contact': 'Kundenkontakt',
    'Partner Contact': 'Partnerkontakt',
    Employee: 'Mitarbeiter',
    Active: 'Aktiv',
    Invited: 'Eingeladen',
    'Strictly Necessary': 'Unbedingt erforderlich',
    'These cookies are essential for the proper functioning of the website. They cannot be disabled.':
      'Diese Cookies sind für die ordnungsgemäße Funktion der Website erforderlich. Sie können nicht deaktiviert werden.',
    'These technologies provide authentication, security, routing and consent records. They cannot be disabled.':
      'Diese Technologien ermöglichen Authentifizierung, Sicherheit, Navigation und den Nachweis Ihrer Auswahl. Sie können nicht deaktiviert werden.',
    'WIANCO Portal': 'WIANCO Portal',
    'Stores your cookie consent preferences.': 'Speichert Ihre Cookie-Einwilligungseinstellungen.',
    'Authenticates your Portal account and maintains single sign-on.':
      'Authentifiziert Ihr Portalkonto und hält die zentrale Anmeldung aufrecht.',
    'Maintains authenticated sessions in the embedded Portal services.':
      'Hält authentifizierte Sitzungen in den eingebundenen Portal-Diensten aufrecht.',
    'Protects forms and state-changing requests against cross-site request forgery.':
      'Schützt Formulare und ändernde Anfragen vor Cross-Site-Request-Forgery.',
    'Records your privacy and storage preferences, their date and policy version.':
      'Speichert Ihre Datenschutz- und Speicherauswahl, deren Datum und die Richtlinienversion.',
    'Temporarily maintains the active Portal authentication token.':
      'Hält das aktive Portal-Authentifizierungstoken vorübergehend vor.',
    'Returns you to the requested page after login and prevents repeated version reloads.':
      'Führt Sie nach der Anmeldung zur angeforderten Seite zurück und verhindert wiederholte Versions-Neuladungen.',
    'Session or configured login lifetime': 'Sitzung oder festgelegte Anmeldedauer',
    'Up to 8 hours': 'Bis zu 8 Stunden',
    'Until deleted or the policy version changes':
      'Bis zur Löschung oder Änderung der Richtlinienversion',
    'Browser tab session': 'Browser-Tab-Sitzung',
    'Maintains your active session.': 'Erhält Ihre aktive Sitzung aufrecht.',
    '1 year': '1 Jahr',
    Session: 'Sitzung',
    Functional: 'Funktional',
    'These cookies allow the website to remember choices you make and provide enhanced features.':
      'Diese Cookies ermöglichen es der Website, sich Ihre Auswahl zu merken und erweiterte Funktionen bereitzustellen.',
    'These local settings remember interface choices you make. The Portal remains usable without optional preferences.':
      'Diese lokalen Einstellungen merken sich Ihre Auswahl für die Benutzeroberfläche. Das Portal bleibt ohne optionale Einstellungen nutzbar.',
    'Stores your preferred theme (light/dark).': 'Speichert Ihr bevorzugtes Design (hell/dunkel).',
    'Stores your preferred language.': 'Speichert Ihre bevorzugte Sprache.',
    'Stores your selected light or dark theme in the Portal and embedded services.':
      'Speichert das gewählte helle oder dunkle Design im Portal und in den eingebundenen Diensten.',
    'Stores your selected interface language.':
      'Speichert die gewählte Sprache der Benutzeroberfläche.',
    'Stores the position selected for the mobile overview control.':
      'Speichert die gewählte Position der mobilen Übersichts-Schaltfläche.',
    'Stores the local high score of the optional offline error-page game.':
      'Speichert den lokalen Höchststand des optionalen Spiels auf der Fehlerseite.',
    'Until deleted': 'Bis zur Löschung',
    Analytics: 'Analyse',
    'These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.':
      'Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Website interagieren, indem Informationen anonym gesammelt und gemeldet werden.',
    'Used to distinguish users.': 'Wird verwendet, um Benutzer zu unterscheiden.',
    '2 years': '2 Jahre',
    '24 hours': '24 Stunden',
    cookie: 'Cookie',
    localStorage: 'Lokaler Speicher',
    sessionStorage: 'Sitzungsspeicher',
    Marketing: 'Marketing',
    'These cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user.':
      'Diese Cookies werden verwendet, um Besucher über Websites hinweg zu verfolgen. Ziel ist es, relevante und ansprechende Werbung für den jeweiligen Nutzer anzuzeigen.',
    'Used by Facebook to deliver a series of advertisement products such as real time bidding from third party advertisers.':
      'Wird von Facebook verwendet, um verschiedene Werbeprodukte wie Echtzeitgebote von Drittanbietern bereitzustellen.',
    '3 months': '3 Monate',
    'Cookie consent banner': 'Cookie-Einwilligungsbanner',
    'We value your privacy': 'Ihre Privatsphäre ist uns wichtig',
    'We use necessary technologies for secure Portal operation and optional preference storage for interface settings. You can accept optional preferences, reject them or choose individually.':
      'Wir verwenden erforderliche Technologien für den sicheren Portalbetrieb und optionale Speicherung für Oberflächeneinstellungen. Sie können optionale Einstellungen akzeptieren, ablehnen oder einzeln auswählen.',
    'We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.':
      'Wir verwenden Cookies, um Ihr Nutzungserlebnis zu verbessern, personalisierte Inhalte oder Werbung bereitzustellen und unseren Datenverkehr zu analysieren. Mit Klick auf â€žAlle akzeptierenâ€œ stimmen Sie der Verwendung von Cookies zu.',
    Customize: 'Anpassen',
    'Reject All': 'Alle ablehnen',
    'Accept All': 'Alle akzeptieren',
    'Cookie Preferences': 'Cookie-Einstellungen',
    Close: 'Schließen',
    'We use cookies to help you navigate efficiently and perform certain functions. You will find detailed information about all cookies under each consent category below.':
      'Wir verwenden Cookies, um Ihnen eine effiziente Navigation zu ermöglichen und bestimmte Funktionen bereitzustellen. Detaillierte Informationen zu allen Cookies finden Sie unten in den jeweiligen Einwilligungskategorien.',
    'We use necessary technologies for secure authentication and Portal operation. Optional preference storage remembers interface settings. Details are listed below.':
      'Wir verwenden erforderliche Technologien für die sichere Authentifizierung und den Portalbetrieb. Optionale Speicherung merkt sich Oberflächeneinstellungen. Einzelheiten finden Sie unten.',
    'The cookies that are categorized as "Necessary" are stored on your browser as they are essential for enabling the basic functionalities of the site.':
      'Cookies der Kategorie â€žErforderlichâ€œ werden in Ihrem Browser gespeichert, da sie für die grundlegenden Funktionen der Website notwendig sind.',
    'Necessary technologies are always active because the requested Portal service cannot be provided securely without them.':
      'Erforderliche Technologien sind immer aktiv, weil der angeforderte Portal-Dienst ohne sie nicht sicher bereitgestellt werden kann.',
    'Read our Privacy Policy': 'Lesen Sie unsere Datenschutzerklärung',
    'Allow All': 'Alle erlauben',
    'Always Active': 'Immer aktiv',
    'View Cookies': 'Cookies anzeigen',
    'Return Home': 'Zur Startseite',
    'Return to overview': 'Zur Übersicht',
    'The page you are looking for does not exist in this workspace.':
      'Die gesuchte Seite existiert in diesem Arbeitsbereich nicht.',
    'Checking authentication': 'Authentifizierung wird geprüft',
    'Initializing Session': 'Sitzung wird initialisiert',
    'Preparing secure portal context': 'Sicherer Portal-Kontext wird vorbereitet',
    'WIANCO Portal. All rights reserved.': 'WIANCO Portal. Alle Rechte vorbehalten.',
    Home: 'Start',
    Operator: 'Operator',
    Email: 'E-Mail',
    Role: 'Rolle',
    'for details.': 'für Details.',
    'We use cookies to support session handling and preferences. See our':
      'Wir verwenden Cookies für Sitzungsverwaltung und Einstellungen. Siehe unsere',
    'Secure session active': 'Sichere Sitzung aktiv',
    'Sign out': 'Abmelden',
  },
};
